import './style.scss';

export function inner_block() {
    const blocks = document.querySelectorAll('.inner_block');
    if (!blocks.length) return;

    blocks.forEach(initOne);
}

function initOne(block) {
    const tabsContainer = block.querySelector('.desktop-tabs');
    if (!tabsContainer) return;

    const tabs = Array.from(tabsContainer.querySelectorAll('.tab[href]'));
    if (!tabs.length) return;

    const wrapper = block.querySelector('.discover-wrapper');

    // Parse target id from href (supports full URL or #hash)
    const getTargetId = (href) => {
        try {
            const u = new URL(href, window.location.href);
            // same-page hash
            if (u.origin === location.origin && u.pathname === location.pathname && u.hash) return u.hash.slice(1);
            if (href.startsWith('#')) return href.slice(1);
            return u.hash ? u.hash.slice(1) : null;
        } catch {
            return href.startsWith('#') ? href.slice(1) : null;
        }
    };

    // Build map (tab -> section) — NOTE: ids must be unique on the page
    const map = tabs
        .map((a) => {
            const id = getTargetId(a.getAttribute('href') || '');
            const el = id ? document.getElementById(id) : null; // global by spec
            const controllerEl = el ? el.querySelector('.controller-bar') : null;
            return { id, tab: a, el, controllerEl };
        })
        .filter((x) => x.id && x.el);

    if (!map.length) return;

    // Desktop vs Mobile
    const mq = window.matchMedia('(min-width: 992px)');
    const isDesktop = () => mq.matches;

    // Trigger lines (desktop: tabs' edges, mobile: viewport halfway)
    const getTriggerYTop = () => {
        if (!isDesktop()) return wrapper ? wrapper.offsetHeight : 0;
        if (!tabsContainer) return 0;
        return parseFloat(window.getComputedStyle(tabsContainer).top) || 0;
    };
    const getTriggerYBottom = () => (isDesktop() ? tabsContainer.getBoundingClientRect().bottom : 160);

    // Activate a tab
    const setActive = (id) => {
        map.forEach(({ id: secId, tab, controllerEl }) => {
            const on = secId === id;
            tab.classList.toggle('active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
            controllerEl?.classList.toggle('active-controller', on);
        });
    };

    // Scrollspy (desktop: when section top crosses tabs' bottom; mobile: viewport top)
    const updateFromScroll = () => {
        const triggerY = getTriggerYBottom();
        let current = null;

        for (const item of map) {
            const r = item.el.getBoundingClientRect();
            const crosses = r.top <= triggerY && r.bottom > triggerY;
            if (crosses) {
                current = item;
                break;
            }
        }

        if (!current) {
            current = map
                .map((t) => {
                    const r = t.el.getBoundingClientRect();
                    return { t, dist: Math.abs(r.top - triggerY) };
                })
                .sort((a, b) => a.dist - b.dist)[0]?.t || null;
        }

        setActive(current?.id || null);
    };

    // Click → smooth scroll (desktop align to tabs' top, mobile to viewport top)
    let suppressUntil = 0;

    const scrollToTarget = (id) => {
        const target = document.getElementById(id);
        if (!target) return;

        const triggerYTop = getTriggerYTop();
        const r = target.getBoundingClientRect();
        const top = window.scrollY + r.top - triggerYTop + 1;

        suppressUntil = Date.now() + 700;
        setActive(id);
        window.scrollTo({ top, behavior: 'smooth' });
    };

    tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
            const href = tab.getAttribute('href') || '';
            const id = getTargetId(href);
            if (!id) return; // external link → allow default
            e.preventDefault();

            if (window.matchMedia('(max-width: 991px)').matches && wrapper) {
                if (!wrapper.classList.contains('open')) {
                    wrapper.classList.add('open');
                    return;
                } else {
                    wrapper.classList.remove('open');
                    if (tab.classList.contains('active')) {
                        return;
                    }
                    // Wait for accordion to collapse before scrolling
                    setTimeout(() => {
                        scrollToTarget(id);
                    }, 350);
                    return;
                }
            }

            scrollToTarget(id);
        });
    });

    // Throttled listeners (per instance is fine)
    let ticking = false;
    const onScrollOrResize = () => {
        if (Date.now() < suppressUntil) return;
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            ticking = false;
            updateFromScroll();
        });
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    mq.addEventListener?.('change', updateFromScroll);

    // Initial
    requestAnimationFrame(() => {
        // Deep link only if hash matches one of this block's targets (optional)
        const hash = window.location.hash?.slice(1);
        const preferred = hash && map.find((t) => t.id === hash);
        if (preferred) setActive(preferred.id);
        else updateFromScroll();
    });
}
